<template>
  <span
    class="com-bot-config-enhance-link-common-link-text"
    @click.stop="onTextNodeClick"
  >{{ displayText }}</span>
</template>
<script lang="ts" setup>
import LinkIgnore from '@/component/message/text/component/common-link/hooks/link-ignore';
import { PropType, onBeforeMount } from 'vue';
import { useToast } from '@/component/kk-toast';
const { error } = useToast();

const props = defineProps({ displayName: { type: String, default: '' }, ext: { type: Object as PropType<Record<string, unknown>>, default: () => null } });

const displayText = LinkIgnore();
let gid = 0;
let botId = 0;
let params = {};

function onTextNodeClick(): void {
  error('暂不支持跳转~');// TODO 替换toast
  // this.$toast('暂不支持跳转~');
}
onBeforeMount(() => {
  const { gid: extGid, botId: extBotId, params: extParams } = props.ext;

  if (gid > 0) {
    gid = extGid as number;
  } else {
    gid = 0;
  }
  if (botId > 0) {
    botId = extBotId as number;
  } else {
    botId = 0;
  }
  if (typeof extParams === 'object') {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    params = extParams as Record<string, unknown>;
  }
});

</script>

<style lang="scss">
.com-bot-config-enhance-link-common-link-text {
  color: #267be7;
  cursor: pointer;
}
</style>
